import React, { FC, Fragment } from 'react';

import { Typography, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';

import { numberWithCommas } from '@helpers/utils';

type BundleHeaderPriceProps = {
  salePrice: number;
  fullPrice: number;
};
const BundleHeaderPrice: FC<BundleHeaderPriceProps> = ({ salePrice, fullPrice }) => {
  const { t } = useTranslation('store_course');
  const theme = useTheme();

  const isFree = salePrice === 0;

  if (isFree) {
    return (
      <Typography component="span" variant="textExtraLarge" color="white">
        {t('course_detail.header_banner.purchase.free_course.text')}
      </Typography>
    );
  }

  return (
    <Fragment>
      <Typography component="span" variant="textExtraLarge" color="white">
        {t('course_detail.header_banner.price', { price: numberWithCommas(salePrice) })}
      </Typography>
      {salePrice < fullPrice ? (
        <Typography
          component="span"
          className="strike-center"
          sx={{
            color: theme.palette.textOnPrimary.secondary,
            mx: { md: '1.5rem', xs: '1rem' },
            fontSize: '24px',
            fontWeight: 400,
            lineHeight: '36px',
            position: 'relative',
            bottom: { md: '4px', xs: '1px' },
          }}
        >
          {t('course_detail.header_banner.price', { price: numberWithCommas(fullPrice) })}
        </Typography>
      ) : null}
    </Fragment>
  );
};

export default BundleHeaderPrice;
